import { ActionEnum } from '../enum/action.enum';
import { action } from 'mobx';
import { ActionFunction } from '../interface/action/action-function.type';
import { isBlockDragDisabled } from '../util/block/is-block-drag-disabled.util';
import { noop } from '../util/action/type/noop-action.util';

export const manageEditor$: ActionFunction = (action$, {state}) => {
  return action$
    .type(ActionEnum.MANAGE_EDITOR)
    .map(action(() => {
      if (!state.configuration.inAdmin || !state.activeDesign.data) {
        return noop();
      }
      state.editor.designBuildingBlocks.forEach((block) => {
        block.isDragDisabled = isBlockDragDisabled(state.activeDesign.data.blocks, block, state);
      });
      return noop();
    }));
};

export default {
  actions: [
    manageEditor$
  ]
};
